import { useContext } from "react";
import { useState, useEffect } from 'react';
import { useForm } from "react-hook-form";
import './authentication.css';
import { useQuery } from 'react-query';
import * as Api from '../../api/Api';
import * as KeyNames from '../../api/KeyNames';
import * as PathNames from '../../api/PathNames';
import { ErrorConnection } from '../../Components/Error/Error';
import { Loading } from '../../Components/Loading/Loading';
import { FeedbackContext } from "../../Components/Context/FeedbackContext";
import { generateToken } from '../../Components/Utils/Utils';
import moment from "moment";
import BackButton from "../../Components/Buttons/BackButton"
import VerifyEmailPage from './verify';

export function ForgotPassword() {
    const { feedbackContext, setFeedbackContext } = useContext(FeedbackContext);

    let resetToken;
    const [resetData, setResetData] = useState(null);

    const { register, handleSubmit, formState: { errors } } = useForm();
    const onSubmit = data => {
        resetToken = generateToken();
        setResetData({ ...data,
            resetToken: resetToken,
            url: PathNames.RouteResetPassword + '?q=' + resetToken,
            expirationTime: new moment().add(2, 'h').toDate().toISOString()
            });
    }

    let { data, isLoading, isError, error } = useQuery([KeyNames.SessionData, resetData ? resetData.resetToken : ""],
        async () => await Api.postForgotPasswordRequest(resetData),
        { enabled: Boolean(resetData) }
    );


    useEffect(() => {
        if (data) {

            if (data.success) {
                localStorage.setItem(KeyNames.SessionReset, JSON.stringify(resetData));
            } else {
                setFeedbackContext({ ...feedbackContext, showError: true, idError: data.errorId });
            }
        }

    }, [data]);

    if (isLoading) return (<Loading />)
    if (isError) return (<ErrorConnection error={error/*.response.status*/} />)

    if (data) {
        if (data.success) {
            return (<VerifyEmailPage />)
        }
    }

    return (
        <form onSubmit={handleSubmit(onSubmit)}
            className='form w-100'
            id='kt_login_signin_form'
        >
            <div className='text-center mb-10'>
                <h1 className='text-dark mb-3'>¿ Has olvidado tu contraseña ?</h1>
                <div className="text-gray-400 fw-bold fs-4">Ingrese su correo electrónico para restablecer su contraseña.</div>
            </div>
            <div className='fv-row mb-10'>
                <label className='form-label fs-6 fw-bolder text-dark'>Correo Electrónico</label>
                <input {...register("email", { required: true })}
                    placeholder=''
                    className=
                    'form-control form-control-lg form-control-solid'
                    type='email'
                    name='email'
                    autoComplete='off'
                />
                <>{errors.email && <span className="text-danger">Ingresar Correo</span>}</>
            </div>
            <div className='d-flex flex-wrap justify-content-center pb-lg-0'>
                <button
                    type='submit'
                    id='kt_sign_in_submit'
                    className='btn btn-lg btn-primary fw-bolder me-4'

                >
                    <span className='indicator-label'>Continuar</span>
                </button>

                <BackButton />

            </div>
        </form>
    )
}
